import React from "react";
import Noti from "../../../util/noti";

import SiteCreationChild from "./SiteCreationChild";

import { useRouteWithData } from'../../../util/router';
import { Redirect } from 'react-router-dom';
import { AccountingForm } from "./AccountingForm";

function SiteCreationInvoicingForm() {

  const { getData } = useRouteWithData();
  const routeState = getData();

  if(!routeState) {
    return <Redirect to="/solar/administration/site-creation/manage-site/invoicing-info-table" />
  }

	return (
		<SiteCreationChild hideNavBar={true} requiredRoles={['administration:SiteCreation:_view']}>
			<AccountingForm siteInfo={routeState.siteInfo} />
			<Noti />
		</SiteCreationChild>
	);
}

export default SiteCreationInvoicingForm;
